import { render, staticRenderFns } from "./ColorText.vue?vue&type=template&id=53f47bb5&"
import script from "./ColorText.vue?vue&type=script&lang=js&"
export * from "./ColorText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports